/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Avg_Pace_One_LinerInputs */

const en_exp_avg_pace_one_liner = /** @type {(inputs: Exp_Avg_Pace_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your average time per kilometer, the primary intensity metric for running.`)
};

const de_exp_avg_pace_one_liner = /** @type {(inputs: Exp_Avg_Pace_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine durchschnittliche Zeit pro Kilometer — die Kernmetrik fürs Laufen.`)
};

/**
* | output |
* | --- |
* | "Your average time per kilometer, the primary intensity metric for running." |
*
* @param {Exp_Avg_Pace_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_avg_pace_one_liner = /** @type {((inputs?: Exp_Avg_Pace_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Avg_Pace_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_avg_pace_one_liner(inputs)
	return de_exp_avg_pace_one_liner(inputs)
});